import { customElement } from 'lit/decorators.js';
import { tagName } from '../../helpers/element.helper';
import { TooltipComponent } from '../tooltip/tooltip.component';

@customElement(tagName('popover'))
export class PopoverComponent extends TooltipComponent {
  protected override get triggerElement() {
    return this;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'a-popover': PopoverComponent;
  }
}
